module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "wrapper-padding-bottom"
  }, [_vm._m(0), _vm._v(" "), (_vm.first.title) ? _c('div', {
    staticClass: "span-full bgwhite",
    attrs: {
      "data-type": "layout",
      "id": "say-no",
      "data-header": "green"
    }
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('div', {
    staticClass: "table-cell"
  }, [_c('h2', {
    staticClass: "green"
  }, [_vm._v(_vm._s(_vm.first.title))]), _vm._v(" "), _c('div', {
    staticClass: "content-960 black mt3"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.first.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-btn"
  }, [(_vm.first.link_title) ? _c('a', {
    staticClass: "btn btn-green mt3",
    attrs: {
      "href": _vm.first.link_url
    }
  }, [_vm._v(_vm._s(_vm.first.link_title))]) : _vm._e()])])])]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "data-type": "layout"
    }
  }, [(_vm.blue_slider.title) ? _c('swiper', {
    ref: "blueSwiper",
    staticClass: "span-swiper span-swiper-full span-full full-transitions bgblue",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "white",
    domProps: {
      "innerHTML": _vm._s(_vm.blue_slider.title)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h3', {
    staticClass: "white no-br content-500",
    domProps: {
      "innerHTML": _vm._s(_vm.blue_slider.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3 content-750",
    domProps: {
      "innerHTML": _vm._s(_vm.blue_slider.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-btn"
  }, [(_vm.blue_slider.link_title) ? _c('a', {
    staticClass: "btn btn-white mt3",
    attrs: {
      "href": _vm.blue_slider.link_url
    }
  }, [_vm._v(_vm._s(_vm.blue_slider.link_title))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "data-type": "layout"
    }
  }, [(_vm.green_slider.title) ? _c('swiper', {
    ref: "greenSwiper",
    staticClass: "span-swiper span-swiper-full span-full full-transitions bggreen",
    attrs: {
      "id": 'green-swiper',
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "white",
    domProps: {
      "innerHTML": _vm._s(_vm.green_slider.title)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h3', {
    staticClass: "white no-br",
    domProps: {
      "innerHTML": _vm._s(_vm.green_slider.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3 content-750",
    domProps: {
      "innerHTML": _vm._s(_vm.green_slider.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-btn"
  }, [(_vm.green_slider.link_title) ? _c('a', {
    staticClass: "btn btn-white mt3",
    attrs: {
      "href": _vm.green_slider.link_url
    }
  }, [_vm._v(_vm._s(_vm.green_slider.link_title))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.greenActive === 1),
      expression: "greenActive === 1"
    }],
    staticClass: "full-bottom-logo",
    attrs: {
      "target": "_blank",
      "href": "//www.plasticpollutioncoalition.org/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/footer-credits-naturaplastickill-2.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('footer-app')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-full span-full-bg bgblue relative",
    staticStyle: {
      "background-image": "url('/static/images/home-bg.png')"
    },
    attrs: {
      "data-type": "layout"
    }
  }, [_c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "0"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more green",
    attrs: {
      "href": "#",
      "data-index": "1"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "2"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "3"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ea1134e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 163
// module chunks = 1